export default __webpack_public_path__ + "static/media/Pit Fighter's Icon of Rapture.c10ff6be.jpg";